
import { isOfflineExemptRoute } from '~/utils/offline-routes.js'

export default ({  store, app, redirect }) => {

  if(!process.client)
    return;

  app.router.beforeEach((to, from, next) => {
    // After a full page load, the first navigation has no from.name — skip or we'd reload again.
    if (!from.name) {
      return next()
    }

    const enteringPayment = to.name === 'payment' && from.name !== 'payment'
    const leavingPayment = from.name === 'payment' && to.name !== 'payment'

    if (enteringPayment || leavingPayment) {
      window.location.href = app.router.resolve(to).href // full reload for payment CSP
      return next(false)
    }

    next()
  })

  app.router.afterEach((route, from) => {


    let step_nav = false;
    switch(route.name){
      case 'delivery':
        step_nav = 1;
      break;
      case 'billing':
        step_nav = 1.5; // billing is a sub-step of delivery
      break;
      case 'payment':
        step_nav = 2;
      break;
      case 'order-confirmation':
      case 'order-received':
        step_nav = 3;
      break;
      default:
        step_nav = false;
    }


    let allowed_checkout_step = store.getters['persisted/getCheckoutStep'];


    const store_status = store.getters.getStoreStatus;
    const account = store.getters.getAccount;

    let loading = store.getters.getLoading; // we've not got any data from the API yet, or in local storage
    if(account.id && !store_status && !loading){ // store not live

        if(!isOfflineExemptRoute(route.name)){
          return redirect('/offline')
        }
        else{
            //next();
        }
    }

    // if the user is before the payment screen then any discount codes should be removed
    // this forces a recalculation of the basket total if it's modified in any way
    if(step_nav < 2){
      store.commit("basket/REMOVE_DISCOUNT_CODE");
    }

    // ensure you can't go passed the checkout step you've not completed
    if (step_nav) {
        if (step_nav > allowed_checkout_step) {
          setTimeout(() => {
            store.commit("persisted/CHECKOUT_STEP",0);
            app.router.replace('/')
          }, 0);
        } else if(step_nav < allowed_checkout_step) {
          // if the page is berore the allowed step then the user has navigated back to a previous step so reduce the allowed step
          store.commit("persisted/CHECKOUT_STEP",step_nav);
        }
    } else {
        store.commit("persisted/CHECKOUT_STEP",0);
    }


  });



}
